import { render } from "./ai-agent-ticket-summary.vue?vue&type=template&id=ba1ade76"
import script from "./ai-agent-ticket-summary.vue?vue&type=script&lang=js"
export * from "./ai-agent-ticket-summary.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__